<template>
  <div class="systemManage-create create-image">
    <el-dialog
      v-model="dialogVisible"
      :title="$t('lcd.Devices.Add AD')"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <div class="form-box">
        <el-form
          label-position="top"
          style="width: 100%"
          :model="formData"
          ref="form"
          :rules="rules"
          size="small"
        >
          <el-form-item :label="$t('lcd.Devices.Store ID')" prop="storeId">
            <el-input
              v-model="formData.storeId"
              placeholder=""
              clearable
              disabled
            />
          </el-form-item>
          <el-form-item
            :label="$t('lcd.NewAdd.MarketingStrategy Name')"
            prop="scheduleAd"
          >
            <el-input v-model="formData.scheduleAd" placeholder="" clearable />
          </el-form-item>
          <el-form-item :label="$t('lcd.NewAdd.Validity')" prop="timeRange">
            <el-date-picker
              v-model="formData.timeRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            :label="$t('lcd.NewAdd.Template Name')"
            prop="templateName"
          >
            <el-input
              v-model="formData.templateName"
              placeholder=""
              clearable
              disabled
              style="width: 100%"
            >
              <el-button
                @click="selectTemp(0)"
                slot="append"
                icon="el-icon-thumb"
              ></el-button>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lcd.NewAdd.DefaultTemplate Name')"
            prop="defaultTemplateName"
          >
            <el-input
              v-model="formData.defaultTemplateName"
              placeholder=""
              clearable
              disabled
            >
              <el-button
                @click="selectTemp(1)"
                slot="append"
                icon="el-icon-thumb"
              ></el-button>
            </el-input>
          </el-form-item>

          <el-form-item :label="$t('lcd.Devices.AD Type')" prop="scheduleType">
            <el-select
              v-model="formData.scheduleType"
              clearable
              :placeholder="$t('layout.Select')"
              @change="scheduleTypeChange"
            >
              <el-option
                v-for="item in scheduleTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- formData.scheduleType为1时是制定设备 formData.scheduleType为2时是指定分组  -->
          <el-form-item
            v-if="formData.scheduleType == 1 || formData.scheduleType == 2"
            :label="$t('lcd.Devices.Device List')"
            prop="scheduleEquipmentList"
          >
            <!-- {{lcdListOptions}} -->
            <el-select
              v-if="formData.scheduleType == 1"
              v-model="formData.scheduleEquipmentList"
              multiple
              filterable
              remote
              automatic-dropdown
              :reserve-keyword="false"
              :placeholder="$t('lcd.Devices.Please Input Device ID')"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in lcdListOptions"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              >
              </el-option>
            </el-select>

            <el-select
              v-if="formData.scheduleType == 2"
              multiple
              filterable
              v-model="formData.scheduleEquipmentList"
              :placeholder="$t('lcd.Devices.Please Select Device Group')"
            >
              <el-option
                v-for="item in lcdTagOptions"
                :key="item.codeId"
                :label="item.codeName"
                :value="item.codeId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lcd.NewAdd.ST')">
            <el-radio-group v-model="formData.periodType">
              <el-radio
                v-for="(item, index) in periodTypeList"
                :key="index"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div
              style="margin-bottom: 10px"
              v-if="formData.periodType == 'year'"
            >
              <el-select
                v-model="formData.selectMonthList"
                :placeholder="$t('lcd.NewAdd.Select month')"
                multiple
                clearable
              >
                <el-option
                  v-for="item in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div
              style="margin-bottom: 10px"
              v-if="
                formData.periodType == 'month' || formData.periodType == 'year'
              "
            >
              <el-select
                v-model="formData.monthsDaysList"
                :placeholder="$t('lcd.NewAdd.Select day')"
                multiple
                clearable
              >
                <el-option
                  v-for="item in monthsList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- {{ formData }} -->
            <div
              style="margin-bottom: 10px"
              v-if="formData.periodType == 'week'"
            >
              <el-select
                v-model="formData.weekDaysList"
                multiple
                clearable
                :placeholder="$t('lcd.NewAdd.Select week')"
              >
                <el-option
                  v-for="item in weekList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <el-time-select
              placeholder="Start time"
              v-model="formData.segmentStartTime"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:00',
                maxTime: formData.segmentEndTime,
              }"
              clearable
            >
            </el-time-select>
            -
            <el-time-select
              placeholder="End time"
              v-model="formData.segmentEndTime"
              :picker-options="{
                start: '00:30',
                step: '00:15',
                end: '23:30',
                minTime: formData.segmentStartTime,
              }"
              clearable
            ></el-time-select>
          </el-form-item>
          <!-- <el-form-item :label="$t('lcd.Devices.AD Info')" prop="launchAdList">
            <el-descriptions
              v-if="formData.launchAdList.length > 0"
              :title="$t('lcd.Devices.AD List')"
              :column="1"
              direction="vertical"
            >
              <el-descriptions-item
                v-for="(item, index) in formData.launchAdList"
                :key="item.id"
                :label="$t('lcd.Devices.AD') + (index + 1)"
              >
                <div class="launchAdList" v-if="materialFlag == 'Img'">
                  <el-image
                    :src="item.url"
                    style="width: 100px; height: auto"
                  ></el-image>
                  <div class="time">
                    <span style="min-width: 60px"
                      >{{ $t("lcd.Devices.Duration") }}：</span
                    >
                    <el-input
                      @change="handleTimeChange(item, index)"
                      size="mini"
                      :disabled="index > 0"
                      style="width: 60px"
                      v-model="item.delay"
                    ></el-input>
                    <span style="padding-left: 20px">S</span>
                  </div>
                </div>
                <div class="launchAdList" v-else>
                  <video style="width: 100px" :src="item.url"></video>
                  <div class="time">
                    <span style="min-width: 60px"
                      >{{ $t("lcd.Devices.Duration") }}：</span
                    >
                    <el-input
                      size="mini"
                      style="width: 60px"
                      disabled
                      v-model="item.delay"
                    ></el-input>
                    <span style="padding-left: 20px">S</span>
                  </div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <el-button icon="el-icon-plus" @click="handleOpen">{{
              $t("lcd.Devices.Add AD Material")
            }}</el-button>
          </el-form-item> -->

          <!-- 保存按钮 -->
          <div class="form-btn-section">
            <el-button
              color="#28C76F"
              size="small"
              @click="handleClose('cancel')"
            >
              {{ $t("button.Cancel") }}</el-button
            >
            <el-button
              color="#28C76F"
              size="small"
              type="success"
              @click="handleConfirm('confirm')"
              >{{ $t("button.Confirm") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>

    <SelectTemp ref="selectTempRef" @getSelectTemp="getSelectTemp"></SelectTemp>
  </div>
</template>
<script>
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口
import {
  getDeviceList,
  addLcdSchedule,
  updateLcdSchedule,
} from "@/libs/api/lcd";
import SelectTemp from "./selectTemp.vue";
export default {
  name: "add-launch",
  components: {
    SelectTemp,
  },
  props: {},
  data() {
    return {
      materialFlag: "All",
      userData: JSON.parse(localStorage.getItem("userData")),
      dialogVisible: false,
      periodTypeList: [
        {
          value: "day",
          label: this.$t("lcd.NewAdd.day"),
        },
        {
          value: "week",
          label: this.$t("lcd.NewAdd.week"),
        },
        {
          value: "month",
          label: this.$t("lcd.NewAdd.month"),
        },
        {
          value: "year",
          label: this.$t("lcd.NewAdd.year"),
        },
      ],
      weekList: [
        
        {
          value: "MON",
          label: this.$t("lcd.NewAdd.Monday"),
        },
        {
          value: "TUE",
          label: this.$t("lcd.NewAdd.Tuesday"),
        },
        {
          value: "WED",
          label: this.$t("lcd.NewAdd.Wednesday"),
        },
        {
          value: "THU",
          label: this.$t("lcd.NewAdd.Thursday"),
        },
        {
          value: "FRI",
          label: this.$t("lcd.NewAdd.Friday"),
        },
        {
          value: "SAT",
          label: this.$t("lcd.NewAdd.Saturday"),
        },
        {
          value: "SUN",
          label: this.$t("lcd.NewAdd.Sunday"),
        },
      ],
      // monthsList: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      monthsList: [
        {
          value: 1,
          label: "1st",
        },
        {
          value: 2,
          label: "2nd",
        },
        {
          value: 3,
          label: "3rd",
        },
        {
          value: 4,
          label: "4th",
        },
        {
          value: 5,
          label: "5th",
        },
        {
          value: 6,
          label: "6th",
        },
        {
          value: 7,
          label: "7th",
        },
        {
          value: 8,
          label: "8th",
        },
        {
          value: 9,
          label: "9th",
        },
        {
          value: 10,
          label: "10th",
        },
        {
          value: 11,
          label: "11th",
        },
        {
          value: 12,
          label: "12th",
        },
        {
          value: 13,
          label: "13th",
        },
        {
          value: 14,
          label: "14th",
        },
        {
          value: 15,
          label: "15th",
        },
        {
          value: 16,
          label: "16th",
        },
        {
          value: 17,
          label: "17th",
        },
        {
          value: 18,
          label: "18th",
        },
        {
          value: 19,
          label: "19th",
        },
        {
          value: 20,
          label: "20th",
        },
        {
          value: 21,
          label: "21st",
        },
        {
          value: 22,
          label: "22nd",
        },
        {
          value: 23,
          label: "23rd",
        },
        {
          value: 24,
          label: "24th",
        },
        {
          value: 25,
          label: "25th",
        },
        {
          value: 26,
          label: "26th",
        },
        {
          value: 27,
          label: "27th",
        },
        {
          value: 28,
          label: "28th",
        },
        {
          value: 29,
          label: "29th",
        },
        {
          value: 30,
          label: "30th",
        },
        {
          value: 31,
          label: "31st",
        },
      ],
      formData: {
        storeId: localStorage.getItem("storeId"),
        scheduleAd: "", // 调度信息	是	String	query
        scheduleType: "", // 调度类型（0:全部 1:指定设备 2：标签类型 3：所有无分组标签设备）
        scheduleEquipmentList: [], // 调度设备	投放类型位1和2时选择
        startTime: "", // 任务开始时间
        endTime: "", // 任务结束时间
        taskTerminal: "0", // 任务来源（1:移动端，其他表示PC端）
        templateId: "", // 时段模板ID（时段内显示）	是	Long	query
        templateName: "", // 时段模板名称（时段内显示）	是	Long	query
        defaultTemplateId: "", // 时段结束模板ID（非时段显示）	是	Long	query
        defaultTemplateName: "", // 时段模板名称（时段内显示）	是	Long	query
        periodType: "day", // 周期类型：day-每天 week-每周 month-每月 year-每年	是	String	query
        selectMonthList: [],
        months: "", // 每年：月份 多选逗号分隔 例：5,10	是	String	query
        weekDaysList: [],
        weekDays: "", // 每周：周几 多选逗号分隔（1=周日 7=周六）例：6,7	是	String	query
        monthsDaysList: [],
        days: "", // 每月/每年：日期 多选逗号分隔 例：1,15	是	String	query
        segmentStartTime: "", //时段开始时间（HH:mm）	是	String	query
        segmentEndTime: "", //时段结束时间（HH:mm）	是
        segmentTimeRange: [], // 投放时间段数组
        launchAdList: [], // 投放广告信息
        timeRange: "",
      },
      rules: {
        scheduleAd: [
          {
            required: true,
            message: this.$t("lcd.NewAdd.Input st name"),
            trigger: "change",
          },
        ],
        templateName: [
          {
            required: true,
            message: this.$t("lcd.NewAdd.Input tempate name"),
            trigger: "change",
          },
        ],
        timeRange: [
          {
            required: true,
            message: this.$t("lcd.NewAdd.Select time range"),
            trigger: "change",
          },
        ],
        defaultTemplateName: [
          {
            required: true,
            message: this.$t("lcd.NewAdd.Input default tempate name"),
            trigger: "change",
          },
        ],
        scheduleType: [
          {
            required: true,
            message: this.$t("lcd.NewAdd.Select device"),
            trigger: "change",
          },
        ],
      },
      loading: false,
      lcdListOptions: [],
      scheduleTypeOptions: [
        {
          value: "0", // 所有设备
          label: this.$t("lcd.Devices.All Device"),
        },
        {
          value: "3", // 所有无分组标签设备
          label: this.$t("lcd.Devices.All No Tag Device"),
        },
        {
          value: "2", // 设备标签分组类型
          label: this.$t("lcd.Devices.Tag Devices"),
        },
        {
          value: "1", // 指定设备
          label: this.$t("lcd.Devices.Define Device"),
        },
      ],
      lcdPageParams: {
        screenCode: "", // 编号
        current: 1,
        size: 999,
        storeType: 2,
      },
      lcdTagOptions: [], // 设备分组列表
      templateType: "",
    };
  },
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.formData.storeId = localStorage.getItem("storeId");
      }
    },
  },
  created() {},
  mounted() {
    this.getCodeList("35");
  },
  methods: {
    async getCodeList(type) {
      try {
        const { data } = await getCodeList({ cateId: type });
        if (data.state === true) {
          let arr = data.data || [];
          if (type == "35") {
            this.lcdTagOptions = arr; // 设备组类型list
          }
        } else {
          this.$message.error(data.message);
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },

    // 投放类型变化时，清空formData.scheduleEquipmentList
    scheduleTypeChange() {
      this.formData.scheduleEquipmentList = [];
    },
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    handleConfirm() {
      this.formData.weekDays =
        this.formData.weekDaysList.length > 0
          ? this.formData.weekDaysList.join(",")
          : "";

      this.formData.days =
        this.formData.monthsDaysList.length > 0
          ? this.formData.monthsDaysList.join(",")
          : "";
      
      this.formData.months =
        this.formData.selectMonthList.length > 0
          ? this.formData.selectMonthList.join(",")
          : "";

      if (
        this.formData.periodType == "week" &&
        this.formData.weekDaysList.length < 1
      ) {
        this.$message.error(this.$t("lcd.NewAdd.Select st time rule"));
        return;
      }

      if (
        this.formData.periodType == "month" &&
        this.formData.monthsDaysList.length < 1
      ) {
        this.$message.error(this.$t("lcd.NewAdd.Select st time rule"));
        return;
      }

      if (
        this.formData.periodType == "year" &&
        (this.formData.monthsDaysList.length < 1 ||
          this.formData.selectMonthList.length < 1)
      ) {
        this.$message.error(this.$t("lcd.NewAdd.Select st time rule"));
        return;
      }
      if (!this.formData.segmentStartTime || !this.formData.segmentEndTime) {
        this.$message.error(this.$t("lcd.NewAdd.Select st time rule"));
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("表单校验通过");
          const params = {
            ...this.formData,
            startTime: this.formData.timeRange[0], // 任务开始时间
            endTime: this.formData.timeRange[1], // 任务结束时间
          };
          console.log(params);
          // return;
          // if (!this.sleepStart || !this.sleepEnd) {
          //   this.$message.error("请设置定时息屏时间段");
          //   return;
          // }
          addLcdSchedule(params).then((res) => {
            console.log(res);
            if (res.data.code == 1) {
              this.$message.success(this.$t("commonMessage.AddSucess"));
              this.$emit("reGetList");
              this.dialogVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          // loading.close()
          console.log("error submit!!");
          return false;
        }
      });
    },

    handleTimeChange(row, index) {
      if (index < 1) {
        this.formData.launchAdList.forEach((item) => {
          item.delay = row.delay;
        });
      }
    },

    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        const params = {
          ...this.lcdPageParams,
          code: query,
          storeId: localStorage.getItem("storeId"),
        };
        getDeviceList(params).then((res) => {
          console.log(res);
          this.loading = false;
          this.lcdListOptions = res.data.data.records;
        });
      } else {
        this.lcdListOptions = [];
      }
    },

    handleOpen() {
      this.$refs.materialSelectRef.open();
    },

    getSelectTemp(row) {
      console.log(row);
      if (this.templateType == 0) {
        this.formData.templateId = row.templateId;
        this.formData.templateName = row.templateName;
      } else {
        this.formData.defaultTemplateId = row.templateId;
        this.formData.defaultTemplateName = row.templateName;
      }
    },

    selectTemp(type) {
      console.log(type);
      this.templateType = type;
      this.$refs.selectTempRef.open();
    },
  },
};
</script>
<style lang="scss" scoped>
.systemManage-create.create-image {
  ::v-deep .el-form--label-top .el-form-item__label {
    padding: 0 !important;
  }
  ::v-deep
    .el-descriptions__body
    .el-descriptions__table
    .el-descriptions-item__cell {
    line-height: 28px;
  }
  // .el-button {
  //   width: 110px;
  // }
  .dialog-footer {
    padding: 20px 0;
  }
  .form-box {
    width: 600px;
  }
  .file-list {
    display: flex;
  }
  .form-btn-section {
    margin-top: 0px;
  }
}
.launchAdList {
  display: flex;
  align-items: center;
  .time {
    margin-left: 40px;
    display: flex;
    align-items: center;
  }
}
</style>